export const localStorageGetArray = <V>(key: string): Array<V> => {
    const storedString = localStorage.getItem(key);

    return storedString ? JSON.parse(storedString) : [];
};

export const localStorageGetMap = <K, V>(key: string): Map<K, V> => {
    return new Map(localStorageGetArray(key));
};

export const localStorageGetSet = <V>(key: string): Set<V> => {
    return new Set(localStorageGetArray(key));
};
export interface LocalStorageStoreIterable {
    maxEntries?: number;
}

export const localStorageStoreIterable = <T>(
    key: string,
    data: Iterable<T>,
    config: LocalStorageStoreIterable | undefined,
): void => {
    const entries = Array.from(data);
    const constrainedEntries = config?.maxEntries
        ? entries.slice(Math.max(0, entries.length - config.maxEntries))
        : entries;

    return localStorage.setItem(key, JSON.stringify(constrainedEntries));
};
